module.exports = __webpack_public_path__ + "static/img/ikonaIrfanDisabled-OFF.8c537b36.png";